import { gql } from 'react-apollo';

export default gql`
  mutation countView($input: ViewInput!) {
    countView(input: $input) {
      offerId
      investorUserId
    }
  }
`;



// WEBPACK FOOTER //
// ./src/apollo/mutations/countView.js